import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { CartProvider } from "@/context/CartContext";
import { QuoteProvider } from "@/components/QuoteDialog";
import Home from "@/pages/Home";
import Sector from "@/pages/Sector";
import Flapjack from "@/pages/Flapjack";
import Chefs from "@/pages/Chefs";
import Resources from "@/pages/Resources";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

const SiteLayout = () => (
  <>
    <Nav />
    <main>
      <Outlet />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <QuoteProvider>
          <SmoothScroll>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/sectors/:slug" element={<Sector />} />
                <Route path="/flapjack" element={<Flapjack />} />
                <Route path="/chefs" element={<Chefs />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
            <CartDrawer />
            <Toaster position="bottom-center" richColors />
          </SmoothScroll>
        </QuoteProvider>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
